/**
 * UI Themes.
 */
enum Theme {
  Light,
  Dark,
}

export default Theme
